import React, { useEffect } from "react";
import { isMobile, isMobileOnly } from "react-device-detect";
import { Skeleton } from "@mui/material";
import { useHistory } from "react-router-dom";
import { Button, Col, Container, Image, Row } from "react-bootstrap";
import axios from "axios";
import { base_url, postHeader } from "../../../../../Helpers/request";
import { useState } from "react";
import { toast } from "react-toastify";
import Slider from "react-slick";
import BannerEngDesktop from '../../../../../../src/Assets/nokaoi-imges/banner-eng.webp'
import BannerAnniDesktop from '../../../../../../src/Assets/nokaoi-imges/banner-anniversery.webp'
import BanneOcasionDesktop from '../../../../../../src/Assets/nokaoi-imges/fn-j.png'
import BannerEngMobile from '../../../../../../src/Assets/nokaoi-imges/banner-eng-mobile.webp'
import BannerAnniMobile from '../../../../../../src/Assets/nokaoi-imges/banner-anniversery-mobile.webp'
import BanneOcasionMobile from '../../../../../../src/Assets/nokaoi-imges/fn-jm.png'
import { NavLink } from "react-router-dom/cjs/react-router-dom";
import leftArrow from '../../../../../Assets/nokaoi-imges/left-arrow.png'
import rightArrow from '../../../../../Assets/nokaoi-imges/right-arrow.png'
import { ar } from "date-fns/locale";

const BannerSlider = () => {
  const history = useHistory();
  const [banner, setBanner] = useState([]);
  const [loading, setLoading] = useState(true);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
     prevArrow: <Image src={leftArrow} alt="arrow"  className="img-fluid"/>,
    nextArrow: <Image src={rightArrow} alt="arrow"  className="img-fluid" />,
    autoplaySpeed: 3000
  };
const bannerData = [
  {
    id: 1,
    image: BannerEngDesktop,
    imageMobile: BannerEngMobile,
    alt: 'Engagement Banner',
    link: '/engagement-rings'
  },
  {
    id: 2,
    image: BannerAnniDesktop,
    imageMobile: BannerAnniMobile,
    alt: 'Anniversary Banner',
    link: '/jewelry/wedding-rings'
  },
  {
    id: 3,
    image: BanneOcasionDesktop,
    imageMobile: BanneOcasionMobile,
    alt: 'Shop by Occasion Banner',
    link: '/jewelry/fine-jewelry'

  }
];

  useEffect(() => {
    //-----------------------------------Banner
    setLoading(true);
    axios
      .get(base_url + `/home/slider`, {
        headers: postHeader,
      })
      .then((response) => {
        if (response.data.status == 1) {
          setLoading(false);
          setBanner(response.data.data);
          localStorage.setItem(
            "bw-bannerdata",
            JSON.stringify(response.data.data)
          );
        } else {
          toast.error(response.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  return (
    <>
      {!loading ? (
       
        <Container fluid>
          <Row>
            <Col sm={12} className="p-0">
             <div className="no_banner_slider">
<Slider {...settings}>
      {banner?.map((banner) => (
        <div key={banner.slider_id}>
          <NavLink to={banner?.btn_link}>
          { isMobile ? <img
              src={banner?.mobile_image}
              alt={banner?.alt_tag}
              style={{ width: '100%', height: 'auto' }}
            />
            :
             <img
              src={banner?.image}
              alt={banner?.alt_tag}
              style={{ width: '100%', height: 'auto' }}
            />
            }
          </NavLink>
        </div>
      ))}
    </Slider>
        </div>
            </Col>
          </Row>
        </Container>
       
      ) 
      
      
      : (
        <div className="sk" style={{ margin: "0px" }}>
          <Skeleton variant="text" animation="wave" height={"90vh"} />
        </div>
      )}
    </>
  );
};

export default BannerSlider;
